import { render, staticRenderFns } from "./LifeCit.vue?vue&type=template&id=3be56cf8&"
import script from "./LifeCit.vue?vue&type=script&lang=js&"
export * from "./LifeCit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports